import React, { useCallback, useEffect, useState } from 'react'
import './Computex.css'
// import React, { useState, useRef } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'
//
// import { useConvertSurvey } from '../hooks/useConvertSurvey'
// import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'
import { templateJson } from './json/templateJson'
import Cookies from 'js-cookie'
import axios from 'axios'

const Computex = () => {
  const [littleGate, setLittleGate] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [availableGifts, setAvailableGifts] = useState([])

  // 檢查是否有可兌換禮品的函數
  const checkAvailableGifts = useCallback(async () => {
    try {
      setIsLoading(true)
      const ac = Cookies.get('computex2025_ac')
      const tk = Cookies.get('computex2025_tk')
      const host = process.env.REACT_APP_HOST || 'https://nezcdev.dataa.com.tw'

      if (!ac || !tk) {
        console.log('缺少 ac 或 tk，無法獲取禮品資訊')
        setIsLoading(false)
        setAvailableGifts([])
        // 設置無可用禮品的 cookie
        Cookies.set('hasAvailableGifts', 'false', {
          expires: 4,
          secure: true,
          sameSite: 'strict',
        })
        // 如果沒有 token，不顯示兌獎按鈕
        setLittleGate(false)
        return
      }

      console.log('正在檢查可用禮品...')

      const response = await axios.post(
        host + '/clientWeb/v1/CheckGift',
        {
          gift_ids: [
            'COMP25_01',
            'COMP25_02',
            'COMP25_03',
            'COMP25_04',
            'COMP25_05',
            'COMP25_06',
          ],
        },
        {
          headers: {
            'Content-Type': 'text/plain; charset=UTF-8',
            Accept: '*/*',
            ac: ac,
            tk: tk,
          },
        }
      )

      console.log('API 回應:', response.data)

      // 過濾出可兌換的禮品
      const availableItems = response.data.data.filter(
        (item) => item.is_available_to_exchange === true
      )
      console.log('可兌換禮品數量:', availableItems.length)

      setAvailableGifts(availableItems)

      if (availableItems.length > 0) {
        // 有可兌換禮品，顯示兌獎按鈕
        Cookies.set('hasAvailableGifts', 'true', {
          expires: 4,
          secure: true,
          sameSite: 'strict',
        })
        setLittleGate(true)
      } else {
        // 沒有可兌換禮品，不顯示兌獎按鈕
        Cookies.set('hasAvailableGifts', 'false', {
          expires: 4,
          secure: true,
          sameSite: 'strict',
        })
        setLittleGate(false)
      }
    } catch (error) {
      console.error('檢查禮品錯誤:', error)
      setAvailableGifts([])
      Cookies.set('hasAvailableGifts', 'false', {
        expires: 4,
        secure: true,
        sameSite: 'strict',
      })
      // 發生錯誤時，不顯示兌獎按鈕
      setLittleGate(false)
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    // 初始檢查
    const initCheck = async () => {
      // 先檢查是否已領獎
      if (Cookies.get('hasReceivedAward') === 'true') {
        // 已領獎，不顯示兌獎按鈕
        console.log('用戶已領獎，不顯示兌獎按鈕')
        setLittleGate(false)
        return
      }

      // 不依賴 cookie 中的 hasAvailableGifts 值，始終調用 API 檢查最新狀態
      console.log('調用 API 檢查可用禮品...')
      await checkAvailableGifts()
    }

    initCheck()
  }, [checkAvailableGifts])

  let computexJson = {
    ...templateJson,
    logo: 'https://i.postimg.cc/9fLpw8NP/AI-wow-2025.jpg',
    title: '【2025 COMPUTEX】BenQ AI WOW',
    completeText: '完成',
    completedHtml: `<h3>感謝您的參與</h3>`,
    pages: [
      {
        name: 'page0',
        elements: [
          {
            type: 'panel',
            elements: [
              {
                type: 'html',
                name: 'intro',
                html: `<div class="computex-content"><div class="computex-div"><a href=${window.location.origin}/P250423112413307><div class="computex-button">中文版</div></a></div>  <div class="computex-div"><a href=${window.location.origin}/P250424001910598><div class="computex-button">English Version</div></a></div></div>`,
              },
            ],
            name: 'panel1',
          },
        ],
      },
    ],
  }

  let littleGateJson = {
    ...templateJson,
    logo: 'https://i.postimg.cc/9fLpw8NP/AI-wow-2025.jpg',
    title: '【2025 COMPUTEX】BenQ AI WOW',
    completeText: '完成',
    completedHtml: `<h3>感謝您的參與</h3>`,
    pages: [
      {
        name: 'page0',
        elements: [
          {
            type: 'panel',
            elements: [
              {
                type: 'html',
                name: 'intro',
                html: `<div class="computex-content"><div class="computex-div"><a href=${window.location.origin}/P250423112413307><div class="computex-button">中文版</div></a></div>  <div class="computex-div"><a href=${window.location.origin}/P250424001910598><div class="computex-button">English Version</div></a></div> <div class="computex-div"><a href=${window.location.origin}/computex-2025-success><div class="computex-button">進行兌獎/Redeem Prize</div></a></div></div>`,
              },
            ],
            name: 'panel1',
          },
        ],
      },
    ],
  }
  // const [survey, setSurvey] = useState(new Model(computexJson))
  const survey = new Model(computexJson)
  const littleGateSurvey = new Model(littleGateJson)
  useEffect(() => {
    // console.log('little', littleGate)
  }, [littleGate])

  // const survey = new Model(computexJson)
  return (
    <>
      <div className="computex-app">
        {littleGate ? (
          <Survey model={littleGateSurvey} />
        ) : (
          <Survey model={survey} />
        )}
      </div>
      {/* <div class="computex-content">
                <div class="computex-div">
                  <a href=${window.location.origin}/p240430105824>
                    <div class="computex-button">中文版</div>
                  </a>
                </div>
                <div class="computex-div">
                <a href=${window.location.origin}/p240430105824>
                  <div class="computex-button">English Version</div>
                </a>
              </div>
</div> */}

      {/* <div className="computex-app">
        <div className="content">
          <p>
            <a href={`${window.location.origin}/p240430105824`}>中文版</a>
          </p>
          <p>
            <a href="https://nezcwebdev.dsigroup.com.tw/">English Version</a>
          </p>
        </div>
      </div> */}

      {/* <p>兌獎的小門
            <a href="https://nezcwebdev.dsigroup.com.tw/">English Version</a>
          </p> */}
    </>
  )
}

export default Computex
